var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.4161V13.8161C17 12.325 15.9802 11.0722 14.6 10.7169M11.8 1.24872C12.9727 1.72343 13.8 2.87316 13.8 4.21611C13.8 5.55906 12.9727 6.7088 11.8 7.18351M13 15.4161C13 13.9251 13 13.1796 12.7564 12.5915C12.4316 11.8074 11.8087 11.1845 11.0246 10.8597C10.4365 10.6161 9.69101 10.6161 8.2 10.6161H5.8C4.30899 10.6161 3.56348 10.6161 2.97541 10.8597C2.19132 11.1845 1.56837 11.8074 1.24359 12.5915C1 13.1796 1 13.9251 1 15.4161M10.2 4.21611C10.2 5.98342 8.76731 7.41611 7 7.41611C5.23269 7.41611 3.8 5.98342 3.8 4.21611C3.8 2.4488 5.23269 1.01611 7 1.01611C8.76731 1.01611 10.2 2.4488 10.2 4.21611Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.735b0a0e16e395ee5f22206d3a869d96.svg";
export { ForwardRef as ReactComponent };